import { useAuth } from 'hooks/auth';
import React from 'react';
import 'react-pro-sidebar/dist/css/styles.css';

/** componentes */
import Layout from '../../components/Layout';
import { DashIcon } from '../../styles/icons';
import Allocation from './Allocation';
import Favorites from './Favorites';

import { Container } from './styles';

const Dashboard: React.FC = () => {
  const { user } = useAuth();
  /*
    const history = useHistory();
    const { httpGet } = useHttp();
      useEffect(() => {
        async function loadUser(): Promise<void> {
          const { data } = await httpGet('/me');
          if (!validateCellPhone(data?.phone, true)) {
            history.push('/profile');
          }
        }
        loadUser();
      }, []);// eslint-disable-line
    */
  return (
    <Layout breadcrumbs={{ icon: DashIcon }}>
      {!user?.allocation && <Allocation />}
      {user?.allocation && (
        <Container>
          <Favorites />
        </Container>
      )}
    </Layout>
  );
};

export default Dashboard;
